import { schema } from 'normalizr';
import membershipSchema from './membershipSchema';

const memberSchema = new schema.Entity('users', {
  membership: membershipSchema,
});

export default memberSchema;
